import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_FILE_BY_ID_PATH,
  GetFileByIdErrorDto,
  GetFileByIdRequestPathVariables,
  GetFileByIdRequestQueryParams,
  GetFileByIdSuccessDto,
} from '@/api/rest/resources/types/file';
import { assertIsDefined } from '@/utils/assert';

export const useFileById = (id: string) => {
  assertIsDefined(id, 'id');

  const pathVariables: GetFileByIdRequestPathVariables = { id };

  const queryFn = () =>
    getRequest<GetFileByIdSuccessDto, GetFileByIdRequestPathVariables, GetFileByIdRequestQueryParams>(
      GET_FILE_BY_ID_PATH,
      pathVariables,
      undefined,
    );

  return useSuspenseQuery<GetFileByIdSuccessDto, GetFileByIdErrorDto>({
    queryKey: ['files', id],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
